module.exports = __webpack_public_path__ + "img/150.3b27d8db.jpg";